import api from "../apiConfig";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getAll(data) {
    let params = "";
    Object.keys(data ?? {}).forEach((key) => {
      if (data[key] !== null && data[key] !== "" && data[key] !== undefined) {
        params += `${key}=${data[key]}&`;
      }
    });
    return api.get(`/api/v1/leave-admin?${params}`);
  },
  approve(id, data) {
    return api.put(`/api/v1/leave-admin/approve/${id}`, data);
  },
};
